<template>
  <div class="classify-page">
    <div class="content-box">
      <div class="box1">
        <!-- <van-search
          v-model="keyword"
          shape="round"
          placeholder="搜索你要的商品"
          @search="getGoodsByCateId"
        /> -->
        <search @search="getGoodsByCateId"></search>
      </div>
      <div class="box2 flex-row">
        <van-sidebar v-model="navActive" style="width: 180px" v-on:change="navChange">
          <van-sidebar-item v-for="(item, index) of topCateList" :key="index" :title="item.name"
            style="font-size: 12px; white-space: nowrap" />
        </van-sidebar>
        <div>
          <!--          <van-tabs v-model="labelActive" v-on:change="labelChange" style="background-color: #EDF0F5;width: 300px">-->
          <!--            <van-tab v-for="item of hotGoodsCate" :name="item.value" :title="item.label"-->
          <!--                     :key="item.value"></van-tab>-->
          <!--          </van-tabs>-->

          <div class="goods-box">
            <img v-if="cateAdsImage" :src="cateAdsImage" alt="" class="banner" />
            <van-grid :border="false" class="cate-list mt8">
              <van-grid-item v-for="item in navList" :key="item.cateId" @click="
                $router.push({
                  path: 'goods-list',
                  query: { cateId: item.cateId },
                })
                ">
                <van-image :src="item.headImage" height="36" lazy-load round width="36"></van-image>
                <div style="font-size: 12px; color: #666666;text-align:center">
                  {{ item.name }}
                </div>
              </van-grid-item>
            </van-grid>
          </div>
        </div>
      </div>
    </div>

    <PageFooter :active="1"></PageFooter>
  </div>
</template>

<script>
import { api_get_goods_cate_list } from "@/api/goods-api";
import GoodsUnit from "@/components/common/goods-unit";
import Vue from "vue";
import { Lazyload } from "vant";
import { GOODS_CATE_INFO } from "@/api/constant";
import PageFooter from "@/components/common/page-footer";

Vue.use(Lazyload);

export default {
  name: "index",
  components: { GoodsUnit, PageFooter },

  data() {
    return {
      // hotGoodsCate: [],
      cateId: 1,
      cateAdsImage: "",
      keyword: "",
      navActive: 0,
      navList: [],
      labelActive: 0,
      goodsList: [],
      topCateList: [],
    };
  },

  created() {
    this.cateId = this.$route.query.cateId || 1;

    api_get_goods_cate_list(this.cateId, null, 0).then((res) => {
      this.topCateList = res.data
        .filter(c => c.cateId !== GOODS_CATE_INFO.books.id)
        .map((item, index) => {
          return {
            name: item.name,
            cateId: item.cateId,
            adsImage: item.adsImage,
            headImage: item.headImage,
          };
        });

      // 默认选择第1个节点
      let firstCateId = this.topCateList[0].cateId;

      api_get_goods_cate_list(firstCateId, null, 0).then((res) => {
        this.navList = res.data.map((item, index) => {
          return {
            name: item.name,
            cateId: item.cateId,
            adsImage: item.adsImage,
            headImage: item.headImage,
          };
        });
      });
    });
  },

  methods: {
    //分类改变
    navChange(e) {
      this.cateId = this.topCateList[e].cateId;
      this.cateAdsImage = this.topCateList[e].adsImage;
      api_get_goods_cate_list(this.cateId, null, 0).then((res) => {
        this.navList = res.data.map((item, index) => {
          return {
            name: item.name,
            cateId: item.cateId,
            adsImage: item.adsImage,
            headImage: item.headImage,
          };
        });
      });
    },

    getGoodsByCateId(value) {
      this.$router.push({
        path: "goods-list",
        query: {
          searchType: 1,
          cateId: this.cateId,
          value,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
